/* eslint-disable camelcase */
import React from 'react'
import { useParams } from 'react-router-dom'
import { useGetAuctionVehicles } from 'utils/hooks/queries'
import {
  FutureSaleVehiclesContext,
  FutureSaleVehiclesContextProps,
  TableData,
  useAlert,
  useAuctionLight,
} from 'contexts'
import { useLoading } from 'utils/hooks'
import { generateAuctionsTableTitleFromLight } from 'utils/helpers/generateAuctionsTable'
import useVehicleModal from 'utils/hooks/useVehicleModal'
import EmptyDataParagraph from 'components/common/EmptyDataParagraph'
import FetchErrorParagraph from 'components/common/FetchErrorParagraph'
import { MRT_Row } from 'material-react-table'
import MaterialTable from 'components/dataTable/MaterialTable'
import useReserveAuthorization from 'utils/hooks/useReserveAuthorization'

const FutureSaleVehiclesPage = () => {
  // TODO: Create AuctionLineUniversalData
  const { Loading } = useLoading()
  const { displayAlert } = useAlert()
  const { auctionLight } = useAuctionLight()
  const { setOpenModal, VehicleModal } = useVehicleModal()
  const { auctionNo } = useParams()

  const searchStr: string = auctionNo !== undefined ? auctionNo : ''
  const {
    data: futureAuctionVehicles,
    isLoading,
    error: getError,
  } = useGetAuctionVehicles(searchStr, 'future')

  const auctionStartDateTime =
    futureAuctionVehicles[0]?.auctionStartDateTime ?? auctionLight.auctionDate

  const { isModificationRestricted, modificationMessage } = useReserveAuthorization({
    auctionStartDateTime,
    // debugOverrideDate: new Date('2025-11-15T10:00:00'),
    // debugOverrideNow: new Date('2025-11-13T18:59:59'),
  })

  const [vehicleModalActiveId, setVehicleModalActiveId] = React.useState<string>('')

  const handleClick = (row: MRT_Row<TableData>) => {
    setVehicleModalActiveId(row.original.no as string)
    setOpenModal(true)
  }
  const isDataEmpty = futureAuctionVehicles.length === 0

  React.useEffect(() => {
    if (getError?.message) {
      displayAlert(`${getError.message}`, 'error')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getError])

  const contextData: FutureSaleVehiclesContextProps = React.useMemo(() => {
    return {
      isModificationRestricted,
      modificationMessage,
      vehicles: futureAuctionVehicles,
    }
  }, [futureAuctionVehicles, modificationMessage, isModificationRestricted])

  if (isLoading) return <Loading />
  if (getError) return <FetchErrorParagraph />
  if (isDataEmpty) return <EmptyDataParagraph />

  return (
    <FutureSaleVehiclesContext.Provider value={contextData}>
      <MaterialTable
        data={futureAuctionVehicles as TableData[]}
        title={generateAuctionsTableTitleFromLight(auctionLight, searchStr)}
        onClick={handleClick}
        key="futureSalesDetails"
      />
      <VehicleModal
        id={vehicleModalActiveId}
        onClose={() => setVehicleModalActiveId('')}
      />
    </FutureSaleVehiclesContext.Provider>
  )
}

export default FutureSaleVehiclesPage
